var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("strong", [_vm._v(_vm._s(_vm.getActorName))]),
      _vm._v(" kullanıcısı:\n    "),
      _vm._l(
        _vm.$_.get(_vm.activity, "payload.assignees"),
        function (assignee, index) {
          return _c("span", { key: index }, [
            _c("strong", [_vm._v(_vm._s(assignee) + " ")]),
            _vm._v(",\n    "),
          ])
        }
      ),
      _vm._v(" "),
      _c("strong", [
        _vm._v(
          '"' + _vm._s(_vm.$_.get(_vm.activity, "payload.taskTitle")) + '"'
        ),
      ]),
      _vm._v(" adlı göreve atadı"),
      _vm.ruleSource
        ? _c("span", [
            _vm._v(" ("),
            _c("em", [_vm._v(_vm._s(_vm.ruleSource))]),
            _vm._v(" aracılığıyla)"),
          ])
        : _vm._e(),
      _vm._v(".\n"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }